// extracted by mini-css-extract-plugin
export default {"section":"VerifyCodePage_section__3duyA","eyebrow":"VerifyCodePage_eyebrow__v0kfb","subheading":"VerifyCodePage_subheading__c4du7"};